import React from 'react'

const Add = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="12" fill="white" />
            <path d="M12 9C12.1326 9 12.2598 9.05268 12.3536 9.14645C12.4473 9.24021 12.5 9.36739 12.5 9.5V12.5H15.5C15.6326 12.5 15.7598 12.5527 15.8536 12.6464C15.9473 12.7402 16 12.8674 16 13C16 13.1326 15.9473 13.2598 15.8536 13.3536C15.7598 13.4473 15.6326 13.5 15.5 13.5H12.5V16.5C12.5 16.6326 12.4473 16.7598 12.3536 16.8536C12.2598 16.9473 12.1326 17 12 17C11.8674 17 11.7402 16.9473 11.6464 16.8536C11.5527 16.7598 11.5 16.6326 11.5 16.5V13.5H8.5C8.36739 13.5 8.24021 13.4473 8.14645 13.3536C8.05268 13.2598 8 13.1326 8 13C8 12.8674 8.05268 12.7402 8.14645 12.6464C8.24021 12.5527 8.36739 12.5 8.5 12.5H11.5V9.5C11.5 9.36739 11.5527 9.24021 11.6464 9.14645C11.7402 9.05268 11.8674 9 12 9Z" fill="blue" />
        </svg>
    )
}

export default Add